import React from 'react';
import NavBar from './components/NavBar';
import { AuthProvider } from './AuthContext';
import AppRouter from './Router';
import Footer from './components/Footer';
import './index.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <NavBar />
        <AppRouter />
        <Footer />
      </AuthProvider>
    </div>
  );
}


export default App;
